import { MaintenanceForwardingEstablishmentChoiceEntryProposalStatus, MaintenanceForwardingSectionsProps } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";

const DirectiveEntryStatusOnGoingEstablishmentChoice = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  const actualProposalStatus = forwarding.establishment_choice_entry.actual_proposal.status;

  if (actualProposalStatus === MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.AwaitingEstablishmentResponse) {
    return (
      <p className="text-white-300">
        Aguardando envio de lance
      </p>
    );
  }

  if (actualProposalStatus === MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.AwaitingClientResponse) {
    return (
      <p className="text-white-300">
        Aguardando aprovação
      </p>
    );
  }

  return null;
}

export default DirectiveEntryStatusOnGoingEstablishmentChoice;
